export enum LoginJourney {
  Username = 'Username',
  Bound = 'Bound',
  Unbound = 'Unbound',
  OtpDeliverySelection = 'OtpDeliverySelection',
  OtpByPhone = 'OtpByPhone',
  OtpInput = 'OtpInput',
  UnboundInvalidCredentials = 'UnboundInvalidCredentials',
  UnableToSendOtp = 'UnableToSendOtp',
}
